<script lang="ts" context="module">
  import type { TransactionStatus } from "../helpers/types";
  import { dateInThePast } from "../helpers/utils";

  // exported so that we can extract the title for filtering.
  export function getTitle(status: string, due_date: string | null) {
    if (status === "unpaid" && !dateInThePast(due_date)) {
      return "waiting for payment";
    }

    switch (status) {
      case "unpaid":
        return "payment due";
      case "partial_refund":
        return "partial refund";
      case "partial":
        return "partially paid";
      case "requires_capture":
        return "pending";
      case "new":
        return "credit requested";
      case "order_new":
        return "order placed";
      case "manual_invoice_new":
        return "Manual Invoice added";
      case "rejected":
        return "credit rejected";
      case "refunded":
        return "paid";

      case "non_pro_invoice_added":
      case "not_required":
      case "creditnote_without_refund":
      case "double_charge":
        return "Paid outside REKKI";

      case "pro_invoice_added":
        // XXX just doing this for now, will make a new status from the backend post-weekend.
        //return "PRO Invoice added";
        return "to be charged";
      case "one_off":
        return "Promotion";
      case "first_order_promo":
        return "PRO 1st order offer";

      case "order_issue":
      case "manual_issue":
      case "invoice_issue":
        return "PRO instant credit";

      case "creditnote":
      case "creditnote_diff_amount":
      case "creditnote_issued":
        return "Credit note applied";

      case "rekki_covers":
        return "Covered by REKKI";

      case "in_progress":
        return "in progress";

      default:
        return status;
    }
  }
</script>

<script lang="ts">
  import Stack from "./Stack.svelte";
  import Text from "./Text.svelte";

  export let status: TransactionStatus;
  export let due_date: string | null;
  export const active: boolean = false;

  function getIcon(status: TransactionStatus) {
    switch (status) {
      case "paid":
      case "unpaid":
      case "partial":
      case "refunded":
        return "static/assets/icons/checkmark.svg";
      case "requires_capture":
      case "in_progress":
        return "static/assets/icons/more.svg";
      case "one_off":
      case "first_order_promo":
      case "order_issue":
      case "invoice_issue":
      case "creditnote":
      case "creditnote_diff_amount":
      case "manual_issue":
      case "rekki_covers":
      case "partial_refund":
        return "static/assets/icons/paid-arrow.svg";
      case "rejected":
        return "static/assets/icons/rejected.svg";
      case "new":
        return "static/assets/icons/paid-arrow.svg";
      case "order_new":
      case "manual_invoice_new":
        return "static/assets/icons/new.svg";
      case "non_pro_invoice_added":
      case "creditnote_without_refund":
        return "static/assets/icons/new.svg";
      case "pro_invoice_added":
        return "static/assets/icons/new.svg";

      default:
        return "static/assets/icons/more.svg";
    }
  }

  function getSize(status: TransactionStatus) {
    switch (status) {
      case "paid":
        return 18;
      case "requires_capture":
        return 24;
      case "refunded":
        return 18;
      default:
        return 18;
    }
  }
</script>

<div class="active">
  <Stack horizontal justifyContent="flex-start" alignItems="center">
    <div
      class="icon-container"
      class:paid={status === "paid" || status === "refunded"}
      class:refunded={status === "one_off" ||
        status == "first_order_promo" ||
        status == "order_issue" ||
        status == "invoice_issue" ||
        status == "creditnote" ||
        status == "creditnote_diff_amount" ||
        status == "manual_issue" ||
        status == "rekki_covers"}
      class:pending={status === "requires_capture"}
      class:ordernew={status === "order_new"}
      class:manual_invoice_added={status === "manual_invoice_new"}
      class:new={status === "new"}
      class:rejected={status === "rejected"}
      class:non_pro_invoice_added={status === "non_pro_invoice_added"}
      class:pro_invoice_added={status === "pro_invoice_added"}
    >
      <img src={getIcon(status)} width={getSize(status)} height={getSize(status)} alt="more" />
    </div>
    <Text size="small" ocd>{getTitle(status, due_date)}</Text>
  </Stack>
</div>

<style>
  .icon-container {
    width: 24px;
    min-width: 24px;
    height: 24px;
    border-radius: 12px;
    background-color: var(--rekki-warning);
    margin-right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .active {
    color: var(--rekki-transparency-dark);
  }

  .paid {
    background-color: var(--rekki-success);
  }

  .refunded {
    background-color: var(--rekki-accent);
  }

  .pending {
    background-color: var(--rekki-warning);
  }

  .rejected {
    background-color: var(--rekki-error);
  }

  .new,
  .ordernew,
  .manual_invoice_added {
    background-color: var(--rekki-neutral-03);
  }

  .non_pro_invoice_added,
  .pro_invoice_added {
    background-color: var(--rekki-neutral-03);
  }
</style>
